import React from "react";
import { Typography } from "@mui/material";

import useStyles from "./useStyles";

const Success = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h1" align="center" className={classes.title}>
        Success!
      </Typography>
      <div className={classes.divider} />
      <Typography align="center" className={classes.description}>
        Your Ecard was sent.
        <br />
        May it bring belly-aching laughs to your friends and kin!
      </Typography>
    </div>
  );
};

export default Success;
